
import { defineComponent, PropType } from 'vue'
import { TeamMemberRoleChoices } from '~/types/types'

export default defineComponent({
  name: 'UpdateRoleModal',
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    newRole: {
      type: String as PropType<TeamMemberRoleChoices>,
      required: true
    },
    role: {
      type: String as PropType<TeamMemberRoleChoices>,
      required: true
    },
    email: {
      type: String,
      required: true
    },
    fullName: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      ROLES: {
        [TeamMemberRoleChoices.Admin]: 'administrator',
        [TeamMemberRoleChoices.Contributor]: 'contributor',
        [TeamMemberRoleChoices.Member]: 'member'
      }
    }
  },
  computed: {
    userName(): string {
      return this.fullName ? this.fullName : this.email
    },
    formattedArticle(): string {
      return this.newRole === TeamMemberRoleChoices.Admin ? 'an' : 'a'
    },
    roleAccessMessage(): string {
      if (this.newRole === TeamMemberRoleChoices.Admin) {
        return 'This will give them full access to all repositories and the team, including billing, adding, or removing members.'
      }
      if (this.newRole === TeamMemberRoleChoices.Contributor) {
        return "Contributors don't have any team level access or any access to change repo level settings."
      }
      if (this.newRole === TeamMemberRoleChoices.Member) {
        return 'Members have the ability to activate analysis on new repositories.'
      }
      return 'Are you sure you want to update the role?'
    }
  },
  methods: {
    close(): void {
      this.$emit('close')
    },
    updateRole(): void {
      this.$emit('primary-action', this.email, this.newRole)
    }
  }
})
